import { Action, Module, VuexModule } from "vuex-module-decorators";
import { SystemConfig } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class SystemConfigModule extends VuexModule {
    @Action
    [SystemConfig.showConfig]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/SystemConfig/show`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SystemConfig.updateConfig](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/SystemConfig/update`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}